import React from "react";

interface PreviewValueProps {
  /** The live form value. */
  value: string;
  /** Stand-in shown while `value` is empty. */
  sample: string;
  /** Classes for the slot — the same in both states. */
  className?: string;
}

/** Fallback rule, for places that need the string rather than a node. */
export const orSample = (value: string, sample: string) =>
  value.trim() || sample;

/**
 * A single slot in a preview document. The stand-in is drawn exactly as a
 * filled value is, so the page always reads as a finished document rather
 * than a form with gaps in it — filling the field changes the words and
 * nothing else.
 */
const PreviewValue: React.FC<PreviewValueProps> = ({
  value,
  sample,
  className = "",
}) => <span className={className}>{orSample(value, sample)}</span>;

export default PreviewValue;
